import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, Dropdown, Spinner } from "react-bootstrap";
import { Dropdown as AntdDropdown } from "antd";
import classNames from "classnames";
import logo from "../../../assets/img/illustrations/falcon.png";
import Logo from "../../../components/common/Logo";
//import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
//import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  getPageName,
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
  deleteCookieCredentials,
  clearAllLocalStorageObject,
  sessionExpireHandle
} from "../../../util/helper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { logoutUser, getprofile } from "../../../api/authentication";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import SearchDropDown from "../../../ui-components/SearchDropDown";
import DropdownSelect from "../../../ui-components/DropdownSelect";
import TokensComp from "../../pages/TokensComp";
import AppContext from "../../../context/Context";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightlightIcon from '@mui/icons-material/Nightlight';
import moment from "moment";
import { Select } from "antd";
import { CircleUserRound, LogOut, Menu, Settings, User } from "lucide-react";
const { Option } = Select;

let localStorageObj = getLocalStorageObject("technical-analysis") || {
  chartView: {},
};

const NavbarTop = ({
  defBrokere,
  brokerID,
  optionsTradingType,
  instrumentOptions,
  expiryOptions,
  spotToken,
  futToken,
  source,
  getRealSpotprice,
  selectedBroker,
  setselectedBroker,
  instrument,
  handleInstrumentChange,
  selectExpiry,
  handleExpiryChange,
  isMenuOpen,
  setIsMenuOpen
}) => {
  const {
    config: { isDark },
    setConfig
  } = useContext(AppContext);

  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoder, setloder] = useState(false);
  const navigate = useNavigate()

  const logoutHandle = () =>{
    setConfig("isDark", false);
    navigate('/authentication/logout')
  }

    const settingsMenuItems = [
    {
      key: 'profile',
      icon: <User size={16} />,
      label: 'Profile',
      onClick: () => navigate('/profile')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon:<LogOut size={16} />,
      label: 'Logout',
      onClick: logoutHandle,
      danger: true
    }
  ];

  return (
    <Navbar
      style={{ height: "47px" }}
      className="pe-3 ps-3 pt-0 pb-0 navbar-glass fs--1 navbar-top sticky-kit top-nav-wrap order-window-body"
      expand={"top"}
    >
      <Menu onClick={() => setIsMenuOpen(!isMenuOpen)} className="navbar-menu" />
      <div style={{ height: "47px" }} className="d-flex align-items-center justify-content-center">
        <img className="me-2" src={logo} alt="Logo" width={32} />
      </div>
      <Logo at="navbar-top" width={30} id="topLogo" />

      {location.pathname.includes("algo") && (
        <Nav className="algo-navs" as="ul">
          <Nav.Link as={Link} to="/algo/accounts" className={`algo-nav ${location.pathname === '/algo/accounts' ? 'active-algo-nav' : ''}`}>
            Accounts
          </Nav.Link>
          <Nav.Link as={Link} to="/algo/strategies" className={`algo-nav ${location.pathname === '/algo/strategies' ? 'active-algo-nav' : ''}`}>
            Strategies
          </Nav.Link>
          <Nav.Link as={Link} to="/algo/create-strategy" className={` algo-nav ${location.pathname === '/algo/create-strategy' ? 'active-algo-nav' : ''}`}>
            Create Strategy
          </Nav.Link>
          <Nav.Link as={Link} to="/algo/signals" className={`algo-nav ${location.pathname === '/algo/signals' ? 'active-algo-nav' : ''}`}>
            Signals
          </Nav.Link>
        </Nav>
      )}
      <Nav
        navbar
        className="navbar-nav-icons ms-auto flex-row align-items-center"
        as="ul"
        defaultActiveKey="/"
      // activeKey={active}
      //onSelect={(selectedKey) => setActive(selectedKey)}
      >

        {window.location.pathname === "/terminal" &&
          <>

            {defBrokere && defBrokere.length > 0 && (
              <Nav navbar className="me-2">
                {/* <DropdownSelect
            options={defBrokere.map((item)=>item.toUpperCase())}
            width={140}
            onChange={(e) => setselectedBroker(e)}
            size="middle"
            defaultValue={selectedBroker.toUpperCase()}
            value={selectedBroker.toUpperCase()}
          /> */}
                <Select
                  size={"middle"}
                  style={{ width: 140 }}
                  defaultValue={selectedBroker.toUpperCase()}
                  listHeight={256}
                  onChange={(e) => setselectedBroker(e)}
                  value={selectedBroker.toUpperCase()}

                  dropdownStyle={{
                    zIndex: 99999
                  }}
                >
                  {defBrokere &&
                    defBrokere.map((option) => (
                      <Option key={option.type} value={option.type === "xts" ? option.subType.toUpperCase() + ' ' + (option.type.toUpperCase()) : option.type}>

                        {option.type === "xts" ?
                          <>{option.subType.toUpperCase()} ({option.type.toUpperCase()}) </>
                          : option.type.toUpperCase()
                        }

                      </Option>
                    ))}
                </Select>
              </Nav>
            )}
            <Nav navbar className="me-2">
              <DropdownSelect
                options={brokerID}
                width={150}
                size="middle"
                defaultValue={brokerID[0]}
                value={brokerID[0]}
              />
            </Nav>
            {/* <Nav navbar className="me-2">
        <DropdownSelect
          options={optionsTradingType}
          width={80}
          size="middle"
          defaultValue={optionsTradingType[0]}
          value={optionsTradingType[0]}
        />
      </Nav> */}
            {instrumentOptions && instrumentOptions.length > 0 && (
              <Nav navbar className="me-2">
                <SearchDropDown
                  options={instrumentOptions}
                  width={150}
                  notFoundText="Instrument Not Found !"
                  // onSearch={(e) => handleInstrumentChange(e)}
                  onChange={(e) => handleInstrumentChange(e)}
                  size="middle"
                  defaultValue={instrument}
                  valueId="tradingName"
                />
              </Nav>
            )}

            {selectExpiry && expiryOptions && expiryOptions.length > 0 && (
              <Nav navbar className="me-2">
                <DropdownSelect
                  options={expiryOptions.map((item) => moment(item).format("DD-MMM-YY"))}
                  width={110}
                  onChange={(e) => handleExpiryChange(e)}
                  size="middle"
                  value={moment(selectExpiry).format("DD-MMM-YY") || moment(expiryOptions[0]).format("DD-MMM-YY")}
                />
              </Nav>
            )}
          </>
        }
        {(window.location.pathname.includes("terminal")) && (
          <Nav navbar>
            {spotToken && futToken && (
              <TokensComp
                spotToken={spotToken}
                futToken={futToken}
                source={source}
                getRealSpotprice={getRealSpotprice}
                instrument={instrument}
                expiry={selectExpiry}
              />
            )}
          </Nav>
        )}

        <Nav.Item as="li" className="ml-2">
          <AntdDropdown
            menu={{ items: settingsMenuItems }}
            trigger={['click']}
            placement="bottomRight"
          >
            <a
              className="nav-link account-icon"
              onClick={(e) => e.preventDefault()}
            >
              <CircleUserRound strokeWidth={1.5} size={24} color="#0B5ED7" />
            </a>
          </AntdDropdown>
        </Nav.Item>
      </Nav>
    </Navbar>

  );
};

export default NavbarTop;
